import React from "react";
import { Link } from "react-router-dom";
import { Markup } from "interweave";
import { parseJSON } from "date-fns";
const StarSingleCardSchedule = ({
  id,
  eventType,
  post,
  title,
  description,
  image,
  date,
  time,
  link,
}) => {
  let participate = 0;
  if (eventType.title == "Simple-Post") {
    participate = post?.general_post_payment?.length;
  } else if (eventType.title == "Live-Chat") {
    participate = post?.registered_live_chats?.length;
  } else if (eventType.title == "Q&A") {
    participate = post?.registered_qna?.length;
  } else if (eventType.title == "Meetup-Event") {
    participate = post?.registered_meetup_events?.length;
  } else if (eventType.title == "Learning-Session") {
    participate = post?.registered_learning_sessions?.length;
  } else if (eventType.title == "Greeting") {
    participate = post?.registered_greeting?.length;
  } else if (eventType.title == "Fan-Group") {
    let data =
      JSON.parse(post?.my_user_join) || JSON.parse(post?.another_user_join);
    participate = data.length;
  } else if (eventType.title == "Auction") {
    participate = post?.bidding?.length;
  } else if (eventType.title == "Marketplace") {
    participate = post?.marketplace_order?.length;
  } else if (eventType.title == "Souvenir") {
    participate = post?.souvenir_apply?.length;
  }
  return (
    <>
      <div className="containerSa col-md-3 mb-3">
        <div className="ClassHeadApp">
          <div className="container-lg">
            <div className="ClassHeadC">
              <h5 className="Approved-C fw-bold">{date} </h5>
              <small className="text-light fw-bold">
                <i className="fa-solid fa-clock"></i> {time}{" "}
              </small>
              <p className="text-warning fw-bold">
                Participate : {participate}
              </p>
            </div>
          </div>
        </div>
        <div className="overlayASchedule bg-info ApprovedS">
          <Link to={link}>
            <div className="text-center">
              <button className="fw-bold text-light pb-3 mt-3">
                <i className="fa-solid fa-eye"></i>
              </button>
            </div>
          </Link>

          <div className="containerADS">
            <img src={image} alt="Snow" className="Img-Sch-Event " />

            {/* Background color */}
            <div className="LeftTopScA"> </div>
            {/* Background color */}

            <div className="LeftTopSc">
              <h5 className="mt-2 text-warning title-limit">{title}</h5>
              <Markup className="text-white des-limit" content={description} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StarSingleCardSchedule;
